import {Component, OnDestroy, OnInit} from '@angular/core';
import {Reise} from './types';
import {FirebaseService} from './firebase.service';
import {getFromMapChecked} from '../utils/tools';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-kitereisen',
  templateUrl: './kitereisen.component.html',
  styles: []
})
export class KitereisenComponent implements OnInit, OnDestroy {
  funweek: Reise;
  hamata = new Reise({
    image: 'assets/reisen/hamata_201804.jpg',
    name: 'Hamata April 2018',
    schlagworte: 'Perfekte Bedingungen im warmen Ägypten',
    kitestationName: 'Kite Village',
    kitestationUrl: 'http://www.kite-village.com',
    unterkunftName: 'Kite-Village Wohnwagencamp',
    unterkunftUrl: 'http://www.kite-village.com/lodging/wohnwagencamp/'
  });
  private subscription: Subscription;

  constructor(public service: FirebaseService) {
  }

  ngOnInit() {
    this.subscription = this.service.reisen.subscribe(reisen => {
      if (!reisen) {
        this.funweek = null;
        return;
      }
      this.funweek = getFromMapChecked(reisen.reisenMap, '2022-02-05_funweek', 'reisen');
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
